// tslint:disable
export enum ExtauthProfileUpdateStatus {
    /**
     * @description Update was successful
     */
    Success = 0,
    /**
     * @description Update failed
     */
    Failed = 1,
}
(ExtauthProfileUpdateStatus as any)['SUCCESS'] = 0;
(ExtauthProfileUpdateStatus as any)['FAILED'] = 1;
